module.exports = __webpack_public_path__ + "img/ZNZBZZYJC_3.c55f0065.jpg";